import { Injectable } from '@angular/core';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class FoerderartUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 'foerderarten';

  constructor() {
    super(FoerderartUrlService.URL_PARAMETER, 'foerderarten');
  }
}
